import React from 'react';
import { AlertCircle } from 'lucide-react';

const DEFAULT_MESSAGE =
  'Nuclius Index methodology is pending. Your script can be uploaded and stored as Markdown, but analysis agents are disabled until the new methodology is added under Nuclius-Index-KB.';

type Props = {
  message?: string | null;
  className?: string;
};

/** Empty-state banner when analyse/agents are gated. */
export const MethodologyPendingBanner: React.FC<Props> = ({
  message = DEFAULT_MESSAGE,
  className = '',
}) => (
  <div
    role="status"
    className={`rounded-lg border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm text-amber-100 ${className}`}
  >
    <div className="flex items-start gap-3">
      <AlertCircle className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" aria-hidden />
      <div>
        <p className="font-medium text-amber-50">Methodology pending</p>
        <p className="mt-1 text-amber-100/90">{message || DEFAULT_MESSAGE}</p>
      </div>
    </div>
  </div>
);

export default MethodologyPendingBanner;
